import { Calendar, formatDate } from '@fullcalendar/core'
import dayGridPlugin  from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin  from '@fullcalendar/list'

document.addEventListener('DOMContentLoaded', function() {
  // calendar var
  const calendarEl = document.getElementById('calendar-list')
  const calendarElMini = document.getElementById('calendar-mini')
  
  // arrows icon
  const arrows = `
    <span class="arrow__inner">
    <svg viewBox="0 0 10 9" xmlns="http://www.w3.org/2000/svg" class="arrow__icon">
      <use href="#svg-arrow"/>
    </svg>
    <svg viewBox="0 0 10 9" xmlns="http://www.w3.org/2000/svg" class="arrow__icon arrow__icon--two">
      <use href="#svg-arrow"/>
    </svg>
    </span>
  `
  // get events from html and fix date / filter
  let eventsClone = EVENTS.slice(0)
  eventsClone.forEach( (ev, i) => {
    ev.start = new Date(eventsClone[i].start)
    ev.end = new Date(eventsClone[i].end)
  })

  // setup
  const calendar = new Calendar(calendarEl, {
    plugins: [ listPlugin ],
    defaultView: 'fullListView',
    events: eventsClone,
    height: 'auto',
    header: {
      left:   'prev',
      center: 'title',
      right:  'next'
    },
    eventTimeFormat: { // like '14:30:00'
      hour: '2-digit',
      minute: '2-digit'
    },
    views: {
      fullListView: {
        listDayAltFormat: false,
        listDayFormat: false,
        type: 'listMonth',
        hour: 'numeric',
        minute: '2-digit',
        meridiem: false
      },
    },
    eventRender: function (event) {
      // event var
      const ev = event.event
      function newEventLayout(ev) {
        const day = formatDate(ev.start, {
          day: 'numeric'
        })
        const weekday = formatDate(ev.start, {
          weekday: 'long'
        })
        const timeStart = formatDate(ev.start, {
          hour: 'numeric',
          hour12: true,
          meridiem: 'short',
          minute: '2-digit'
        })
        const timeEnd = formatDate(ev.end, {
          hour: 'numeric',
          hour12: true,
          meridiem: 'short',
          minute: '2-digit'
        })
        const timeStartUTC = new Date(Date.UTC(ev.start))
        console.log("UTC", timeStartUTC)
        let moreInfoLink = '' 
        let moreInfo = ''
        let eventTimes = 'All Day'
        if (ev.allDay === false) {
          eventTimes = `${timeStart} ${ timeEnd ? '- ' + timeEnd : '' } `
        }
        if (ev.extendedProps.description) {
          moreInfoLink = `<span data-dropperid="${ev.id}" class="calendar__more calendar__arrow arrow"><span>More Info</span>${arrows}</span>`
          moreInfo = `<div data-dropid="${ev.id}" class="calendar__drop is-closed">
              <div class="calendar__drop__inner">
                ${ev.extendedProps.description}
              </div>
            </div>`
        }
        const registerLink = ev.extendedProps.registerLink ? `<a href="${ev.extendedProps.registerLink}" class="calendar__arrow arrow">Register${arrows}</a>` : '' 
        // const calLink = ''
        // if (ev.extendedProps.registerLink) {
        const evEndTime = ev.extendedProps.cleanEnd ? ev.extendedProps.cleanEnd : ev.extendedProps.cleanStart
        const googleLink = 'https://www.google.com/calendar/render'
          + '?action=TEMPLATE'
          + '&dates=' + ev.extendedProps.cleanStart + '/' + evEndTime
          + '&text=' + ev.extendedProps.cleanTitle
          + '&details=' + ev.extendedProps.cleanDesc
          + '&location=' + ev.extendedProps.cleanLoc
        const calLink = `<a href="${googleLink}" class="calendar__arrow arrow" target="_blank">Add to Google Calendar${arrows}</a>`

        // const calLink =  `
        //   <span class="calendar__add">
        //     <span class="calendar__arrow arrow">Add to Calendar${arrows}</span>
        //     <span class="calendar__drop">
        //       <a href="${googleLink}" target="_blank">
        //         Google Calendar
        //       </a>
        //     </span>
        //   </span>`
        // }
      
        // const calLink = `<span class="calendar__download calendar__arrow arrow" 
        //   data-cal-title="${ev.title}"
        //   data-cal-desc="${ev.extendedProps.shortDescription}"
        //   data-cal-loc="${ev.extendedProps.location}"
        //   data-cal-start="${ev.start}"
        //   data-cal-end="${ev.end}">
        //     Add to Calendar${arrows}
        //   </span>`
        const output = `<td class="calendar__td">
            <div class="row">
              <div class="calendar__left t-text-color--base col col--xs-15 col--sm-3">
                <div class="calendar__day">
                  ${day}
                </div>
                <div class="calendar__weekday">
                  ${weekday}
                </div>
              </div>
              <div class="calendar__right col col--xs-15 col--sm-12">
                <h2 class="calendar__title">
                  ${ev.title}
                </h2>
                <h3 class="calendar__subtitle t-text-color--base">
                  ${ ev.extendedProps.location ? ev.extendedProps.location + ':' : ''} ${eventTimes}
                </h3>
                <p class="calendar__desc">
                  ${ev.extendedProps.shortDescription}
                </p>
                <div class="calendar__links">
                  ${registerLink}
                  ${moreInfoLink}
                  ${calLink}
                </div>
                ${moreInfo}
              </div>
            </div>
          </td>
        `
        return output
      }
      
      // update event row
      event.el.classList.add('calendar__event')
      event.el.innerHTML = newEventLayout(ev)

      // event download
      // const link = event.el.querySelector('.calendar__download')
      // const calIcs = ics()
      // calIcs.addEvent(link.dataset.calTitle, link.dataset.calDesc, link.dataset.calLoc, link.dataset.calStart, link.dataset.calEnd)
      // link.addEventListener('click', () => {
      //   console.log('click')
      //   calIcs.download()
      // })

      // update calendar layout
      event.view.scroller.overflowX = 'visible'
      event.view.scroller.overflowY = 'visible'

    },
    datesRender: function () {
      const btnNext = document.querySelector('#calendar-list .fc-next-button')
      const btnPrev = document.querySelector('#calendar-list .fc-prev-button')
      btnNext.classList.add('arrow')
      btnPrev.classList.add('arrow', 'arrow--prev')
      btnNext.innerHTML = arrows
      btnPrev.innerHTML = arrows
      btnNext.addEventListener('click', function () {
        calendarMini.next()
      })
      btnPrev.addEventListener('click', function () {
        calendarMini.prev()
      })

      let counter = 1
      let events = document.querySelectorAll('.calendar__event')
      events.forEach( function (event) {
        if(counter % 2 == 0) event.classList.add('calendar__event--even') 
        event.classList.add('calendar__event--' + counter)
        counter++
      })
      setTimeout(function () {
        calendarEl.classList.add('is-updated')
      }, 50)
      setDropLinks()
    },
    datesDestroy: function () {
      calendarEl.classList.remove('is-updated')
    },
    viewSkeletonRender: function (info) {
      // // update buttons
      // const btnNext = document.querySelector('#calendar-list .fc-next-button')
      // const btnPrev = document.querySelector('#calendar-list .fc-prev-button')
      // btnNext.classList.add('arrow')
      // btnPrev.classList.add('arrow', 'arrow--prev')
      // btnNext.innerHTML = arrows
      // btnPrev.innerHTML = arrows
      // btnNext.addEventListener('click', function () {
      //   calendarMini.next()
      // })
      // btnPrev.addEventListener('click', function () {
      //   calendarMini.prev()
      // })
    }
  })

  const calendarMini = new Calendar(calendarElMini, {
    plugins: [ dayGridPlugin, interactionPlugin ],
    defaultView: 'dayGridMonth',
    events: eventsClone,
    fixedWeekCount: false,
    header: {
      left:   '',
      center: 'title',
      right:  ''
    },
    navLinks: true,
    showNonCurrentDates: true,
    eventRender: function (event) {
      // console.log('run events render here')
      // const btnNext = document.querySelector('#calendar-mini .fc-next-button')
      // const btnPrev = document.querySelector('#calendar-mini .fc-prev-button')
      // btnNext.classList.add('arrow')
      // btnPrev.classList.add('arrow', 'arrow--prev')
      // btnNext.innerHTML = arrows
      // btnPrev.innerHTML = arrows
      // btnNext.addEventListener('click', function () {
      //   calendar.next()
      // })
      // btnPrev.addEventListener('click', function () {
      //   calendar.prev()
      // })
      const setDay = formatDate(event.event.start, {day: '2-digit'})
      const setMonth = formatDate(event.event.start, {month: '2-digit'})
      const setYear = formatDate(event.event.start, {year: 'numeric'})
      const setDate = setYear + '-' + setMonth + '-' + setDay
      const gridDay = document.querySelector('#calendar-mini .fc-day-top[data-date="' + setDate + '"]')
      if (gridDay) gridDay.childNodes[0].classList.add('t-text-color--base')
    },
    navLinkDayClick: function (date, jsEvent) {
      // setDropLinks()
    },
    dateClick: function (info) {
      console.log(info)
    },
    viewSkeletonRender: function (info) {
      console.log('skeleton')
      // update buttons
      // const btnNext = document.querySelector('#calendar-mini .fc-next-button')
      // const btnPrev = document.querySelector('#calendar-mini .fc-prev-button')
      // btnNext.classList.add('arrow')
      // btnPrev.classList.add('arrow', 'arrow--prev')
      // btnNext.innerHTML = arrows
      // btnPrev.innerHTML = arrows
      // btnNext.addEventListener('click', function () {
      //   calendar.next()
      // })
      // btnPrev.addEventListener('click', function () {
      //   calendar.prev()
      // })
    }
  })

  // console.log(calendar)
  calendar.render()
  calendarMini.render()
  
})

function setDropLinks() {
  const dropLinks = document.querySelectorAll('[data-dropperid]')
  dropLinks.forEach( link => {
    const id = link.dataset.dropperid
    link.addEventListener('click', () => {
      const drops = document.querySelectorAll('[data-dropid]')
      const drop = document.querySelector('[data-dropid="' + id + '"]')
      if (drop.classList.contains('is-open')) {
        closeDescBox(drop)
      } else {
        drops.forEach( d => {
          if (d.classList.contains('is-open')) closeDescBox(d)
        })
        const innerDiv = drop.querySelector('.calendar__drop__inner')
        const height = innerDiv ? innerDiv.offsetHeight : 0
        openDescBox(drop, height)
      }
    })
  })
}
function closeDescBox(el) {
  const link = document.querySelector('[data-dropperid="' + el.dataset.dropid + '"] span')
  link.innerHTML = 'More Info'
  el.classList.add('is-closed')
  setTimeout( () => el.classList.remove('is-open'), 100 )
  el.style.height = 0 + 'px'
}
function openDescBox(el, height) {
  const link = document.querySelector('[data-dropperid="' + el.dataset.dropid + '"] span')
  link.innerHTML = 'Less Info'
  el.classList.add('is-open')
  setTimeout( () => el.classList.remove('is-closed'), 100 )
  el.style.height = height + 'px'
}
